/* Bid & Buy-pagina: de bod-proef en de doorkliks.

   De proef rekent, meer niet. Hij verstuurt geen bod en doet geen uitspraak
   over de kans dat een bod wordt geaccepteerd: dat oordeel hoort bij een
   mens, en een percentage op deze plek zou de marge verklappen en
   verwachtingen wekken die niemand kan waarmaken.

   Alle bedragen komen uit data-attributen die Liquid heeft gezet, uit de
   echte pakprijs en pakketinhoud van het gekozen product. In dit bestand
   staat geen prijs, geen percentage en geen aanname over het assortiment. */
(function () {
  'use strict';

  var proef = document.querySelector('[data-solza-proef]');

  function geld(centen) {
    if (window.formatMoney && window.MinimogSettings && window.MinimogSettings.money_format) {
      return window.formatMoney(centen, window.MinimogSettings.money_format);
    }
    return '€ ' + (centen / 100).toLocaleString('nl-NL', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function getal(n) {
    return n.toLocaleString('nl-NL', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  }

  function lees(veld) {
    if (!veld) return 0;
    var n = parseFloat(String(veld.value).replace(',', '.'));
    return isNaN(n) || n < 0 ? 0 : n;
  }

  function duw(gebeurtenis, gegevens) {
    window.dataLayer = window.dataLayer || [];
    var lading = { event: gebeurtenis, pageType: 'Page' };
    Object.keys(gegevens || {}).forEach(function (k) {
      lading[k] = gegevens[k];
    });
    window.dataLayer.push(lading);
  }

  if (proef) {
    var prijsM2 = parseInt(proef.dataset.prijsM2, 10) || 0;
    var veldM2 = proef.querySelector('[data-solza-proef-m2]');
    var veldBod = proef.querySelector('[data-solza-proef-bod]');
    var webLabel = proef.querySelector('[data-solza-proef-weblabel]');
    var webTotaal = proef.querySelector('[data-solza-proef-webtotaal]');
    var bodTotaal = proef.querySelector('[data-solza-proef-bodtotaal]');
    var sjabloonWeb = webLabel ? webLabel.textContent : '';

    var verver = function () {
      var m2 = lees(veldM2);
      var bod = lees(veldBod);

      if (webLabel && sjabloonWeb) {
        webLabel.textContent = sjabloonWeb.split('%m2%').join(getal(m2));
      }
      if (webTotaal) {
        webTotaal.textContent = m2 > 0 ? geld(Math.round(prijsM2 * m2)) : '—';
      }
      if (bodTotaal) {
        /* Het bodveld staat in euro's, de rest van de pagina rekent in
           centen. Hier een keer omrekenen, zodat er verderop nergens twee
           eenheden door elkaar lopen. */
        var bodCenten = Math.round(bod * 100);
        bodTotaal.textContent = m2 > 0 && bod > 0 ? geld(Math.round(bodCenten * m2)) : '—';
      }
    };

    if (veldM2) veldM2.addEventListener('input', verver);

    if (veldBod) {
      veldBod.addEventListener('input', verver);

      /* Het event gaat af bij het verlaten van het veld en niet bij elke
         toetsaanslag: anders staat er voor "32" eerst een meting op 3.
         Geen persoonsgegevens, alleen de twee getallen en de vloer. */
      veldBod.addEventListener('change', function () {
        var m2 = lees(veldM2);
        var bod = lees(veldBod);
        if (bod <= 0) return;
        duw('solza_bidbuy_proef_bod', {
          bid_buy: {
            ingevoerde_m2: m2,
            bod_per_m2: bod,
            webshopprijs_per_m2: prijsM2 / 100,
            vloer_handle: proef.dataset.handle || ''
          }
        });
      });
    }

    var vloerlink = proef.querySelector('[data-solza-proef-vloerlink]');
    if (vloerlink) {
      vloerlink.addEventListener('click', function () {
        duw('solza_bidbuy_proefvloer_klik', { bid_buy: { vloer_handle: proef.dataset.handle || '' } });
      });
    }

    verver();
  }

  /* ---------- doorkliks in de startsectie ---------- */

  document.addEventListener('click', function (e) {
    var kaart = e.target.closest && e.target.closest('[data-solza-bidbuy-categorie]');
    if (kaart) {
      duw('solza_bidbuy_categorie_klik', {
        bid_buy: { categorie: kaart.dataset.solzaBidbuyCategorie || '' }
      });
      return;
    }

    var resultaat = e.target.closest && e.target.closest('[data-solza-bidbuy-zoekresultaat]');
    if (resultaat) {
      duw('solza_bidbuy_zoekresultaat_klik', {
        bid_buy: { vloer_handle: resultaat.dataset.solzaBidbuyZoekresultaat || '' }
      });
    }
  });

  /* ---------- terugbelformulier ----------

     Het event gaat af op submit en niet op de bedankpagina, want het
     formulier van Shopify herlaadt de pagina en dan is deze module weg.
     Alleen dat er verstuurd is, geen veldinhoud: hier staan een naam, een
     telefoonnummer en een e-mailadres in, en die horen niet in een
     analytics-gebeurtenis. */
  var terugbel = document.querySelector('.solza-pagina-formulier form');
  if (terugbel) {
    terugbel.addEventListener('submit', function () {
      duw('solza_bidbuy_terugbel_verstuurd', { bid_buy: { formulier: 'terugbellen' } });
    });
  }

  /* ---------- zoekveld ----------

     Gekoppeld aan de voorspellende zoekfunctie van de winkel, zodat de
     bezoeker vanaf deze pagina direct op een vloerpagina uitkomt: daar zit
     de bodknop. Een eigen zoekindex bouwen zou een tweede waarheid geven
     naast de zoekfunctie die de winkel al heeft. */
  var zoek = document.querySelector('[data-solza-bidbuy-zoek]');
  if (zoek) {
    var invoer = zoek.querySelector('input[type="search"], input[type="text"]');
    var uitvoer = zoek.querySelector('[data-solza-bidbuy-zoekuitvoer]');
    var wacht = null;
    var laatste = '';

    var toon = function (producten) {
      if (!uitvoer) return;
      if (!producten.length) {
        uitvoer.innerHTML = '';
        uitvoer.hidden = true;
        return;
      }
      uitvoer.innerHTML = producten
        .map(function (p) {
          return (
            '<li><a href="' + p.url + '" data-solza-bidbuy-zoekresultaat="' + p.handle + '">' +
            (p.beeld ? '<img src="' + p.beeld + '" alt="" loading="lazy" width="40" height="40">' : '') +
            '<span>' + p.titel + '</span></a></li>'
          );
        })
        .join('');
      uitvoer.hidden = false;
    };

    var zoeken = function () {
      var term = (invoer.value || '').trim();
      if (term.length < 3) {
        toon([]);
        return;
      }
      if (term === laatste) return;
      laatste = term;

      var url =
        window.Shopify.routes.root +
        'search/suggest.json?q=' +
        encodeURIComponent(term) +
        '&resources[type]=product&resources[limit]=5';

      fetch(url)
        .then(function (r) {
          return r.json();
        })
        .then(function (d) {
          var lijst = ((d.resources || {}).results || {}).products || [];
          toon(
            lijst.map(function (p) {
              return {
                url: p.url,
                handle: p.handle,
                titel: p.title,
                beeld: p.featured_image ? p.featured_image.url : ''
              };
            })
          );
        })
        .catch(function () {
          /* Zoeken dat niet lukt laat de rest van de pagina met rust. De
             categoriekaarten eronder zijn de tweede route naar hetzelfde. */
          toon([]);
        });
    };

    if (invoer) {
      invoer.addEventListener('input', function () {
        window.clearTimeout(wacht);
        wacht = window.setTimeout(zoeken, 250);
      });
      /* Enter mag niet het formulier posten naar een lege actie; de
         suggesties eronder zijn de bedoeling. */
      zoek.addEventListener('submit', function (e) {
        e.preventDefault();
        zoeken();
      });
    }
  }
})();
